import { Box, Divider, Typography } from "@mui/material";

import DevicesMakesTable from "../devices/components/DevicesMakesTable";
import CreateSKU from "./components/CreateSKU";
import SKUsTable from "./components/SKUsTable";

const SKUsPage = (): JSX.Element => {
  return (
    <Box>
      <Typography variant="h6">SKU Configurations</Typography>
      <Box padding="0.75em 0">
        <CreateSKU />
      </Box>
      <SKUsTable />

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6">Device Makes</Typography>
      <Box padding="0.75em 0">
        <DevicesMakesTable />
      </Box>
    </Box>
  );
};

export default SKUsPage;
